import { render, staticRenderFns } from "./ProductShowcase.vue?vue&type=template&id=8f7becfe&scoped=true"
import script from "./ProductShowcase.vue?vue&type=script&lang=js"
export * from "./ProductShowcase.vue?vue&type=script&lang=js"
import style0 from "./ProductShowcase.vue?vue&type=style&index=0&id=8f7becfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7becfe",
  null
  
)

export default component.exports